module.exports = __webpack_public_path__ + "static/media/login-bg.1f3eaa22.jpg";